import { render, staticRenderFns } from "./LoginCnh.vue?vue&type=template&id=870575f0&scoped=true&"
import script from "./LoginCnh.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LoginCnh.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LoginCnh.vue?vue&type=style&index=0&id=870575f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870575f0",
  null
  
)

export default component.exports